import { render } from "./UploadingRow.vue?vue&type=template&id=0f8dc146&scoped=true"
import script from "./UploadingRow.vue?vue&type=script&lang=js"
export * from "./UploadingRow.vue?vue&type=script&lang=js"

import "./UploadingRow.vue?vue&type=style&index=0&id=0f8dc146&scoped=true&lang=sass"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f8dc146"]])

export default __exports__